import React from 'react';

import Teal from './teal.png';
import ErrorIllustration from './error.svg';
import NotFoundIllustration from './magnifying-glass.svg';
import { IssueType } from '../../../@types/issueType';
import { BASE_PATH } from '../../../domain/routes';
import { getIssuePageContent } from '../../../utils/getIssuePageContent.util';
import { Msg, useIntl } from '@/i18n';

const styles = {
  illustration: {
    width: 335,
  },
  errorIllustration: {
    backgroundImage: `url(${Teal})`,
    backgroundSize: 210,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '14px 95px',
  },
};

type IssuePageProps = {
  type: IssueType;
};

export const IssuePage = ({ type }: IssuePageProps) => {
  const { t } = useIntl();

  const { title, message, link } = getIssuePageContent(type);

  return (
    <div className='align-center margin-horizontal-l margin-vertical-l padding-bottom-xxl'>
      <img
        className='lap-margin-bottom-l desk-margin-bottom-l'
        src={type === IssueType.NOT_FOUND ? NotFoundIllustration : ErrorIllustration}
        alt={t({ id: `issuePage.${type.toLowerCase()}.illustration`, defaultMessage: type })}
        width='346'
        height='346'
        style={{ ...styles.illustration, ...(type !== IssueType.NOT_FOUND && styles.errorIllustration) }}
      />
      {title && (
        <h1 className='font-heading-medium-regular padding-vertical-l'>
          <Msg id={title} defaultMessage='Something went wrong' />
        </h1>
      )}
      {message && (
        <div className='font-heading-xsmall-regular margin-bottom-xxl'>
          <Msg id={message} defaultMessage={type} values={{ br: <br /> }} />
        </div>
      )}
      {link && (
        <a className='button lap-margin-top-m desk-margin-top-m' href={BASE_PATH}>
          <Msg id={link} defaultMessage='Try again' />
        </a>
      )}
    </div>
  );
};
